import { EventEmitter, Injectable } from '@angular/core';

import { SearchKeyType } from '../models/statistics';


@Injectable({
    providedIn: 'root'
})
export class HomeService {

    tableChanged: EventEmitter<void> = new EventEmitter();
    homeRefreshChanged: EventEmitter<void> = new EventEmitter();

    isCardsReadyToRefresh: boolean[] = [false, false, false, false];
    isChartGeneratedDocumentsReadyToRefresh: boolean = false;
    isChartAverageWaitTimeReadyToRefresh: boolean = false;
    isHomeTableReadyToRefresh: boolean = false;

    notifyTableChange(): void {
        this.tableChanged.emit();
    }

    notifyHomeRefreshChange(): void {
        this.homeRefreshChanged.emit();
    }

    cardByNumberReadyToRefresh(cardId: number): void {
        this.isCardsReadyToRefresh[cardId] = true;
    }

    chartReadyToRefresh(keyChart: string): void {
        if (keyChart === SearchKeyType.AverageWaitTime) {
            this.isChartAverageWaitTimeReadyToRefresh = true;
        } else {
            this.isChartGeneratedDocumentsReadyToRefresh = true;
        }
    }
    
    homeTableReadyToRefresh(): void {
        this.isHomeTableReadyToRefresh = true;
    }

    isHomeElementsReadyToRefresh(): boolean {
        return this.isCardsReadyToRefresh.every(cardReady => cardReady)
            && this.isChartGeneratedDocumentsReadyToRefresh
            && this.isChartAverageWaitTimeReadyToRefresh
            && this.isHomeTableReadyToRefresh;    
    }

    resetHomeElementsReadyToRefresh(): void {
        this.isCardsReadyToRefresh = [false, false, false, false];
        this.isChartGeneratedDocumentsReadyToRefresh = false;
        this.isChartAverageWaitTimeReadyToRefresh = false;
        this.isHomeTableReadyToRefresh = false;
    }

}
